if (!customElements.get('landing-feature-highlight-video')) {
  class LandingFeatureHighlightVideo extends HTMLElement {
    constructor() {
      super();
      this.mobileMediaQuery = '(max-width: 750px)';
      this._handleVideoPlay = this.handleVideoPlay.bind(this);

      this.video = this.querySelector('.landing-feature-highlight__video');
    }

    connectedCallback() {      
      const hasAutoplay = this.hasTrueAttribute('autoplay')
      const hasMuted = this.hasTrueAttribute('muted')
      
      if(!hasAutoplay && !hasMuted) {
        return;
      }

      this.addEventListener('click', this._handleVideoPlay);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._handleVideoPlay);
    }

    hasTrueAttribute(attribute) {
      return this.video.hasAttribute(attribute) && this.video.getAttribute(attribute) != 'false'
    }

    isMobileViewport() {
      return window.matchMedia && window.matchMedia(this.mobileMediaQuery).matches;
    }

    getLandingFeatureHighlightVideos() {
      return Array.from(document.querySelectorAll('landing-feature-highlight-video .landing-feature-highlight__video'));
    }

    playVideoSafely(videoElement) {
      if (!videoElement.paused) {
        return;
      }

      videoElement.play();
    }

    playAllLandingFeatureHighlightVideos() {
      const videoElements = this.getLandingFeatureHighlightVideos();
      const hasControls = Boolean(this.video.getAttribute('controls'));

      videoElements.forEach((videoElement) => {
        if (hasControls && videoElement === this.video) {
          return;
        }
        
        this.playVideoSafely(videoElement);
      });
    }

    handleVideoPlay() {
      if (!this.video || !this.isMobileViewport()) {
        return;
      }

      this.playAllLandingFeatureHighlightVideos();
    }
  }

  customElements.define('landing-feature-highlight-video', LandingFeatureHighlightVideo);
}
